<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="31.64" height="28" viewBox="0 0 31.64 28">
        <g id="Group_2683" data-name="Group 2683" transform="translate(-308.36 -156)">
            <circle id="Ellipse_187" data-name="Ellipse 187" cx="14" cy="14" r="14" transform="translate(312 156)"
                    fill="#cedbff"/>
            <g id="Group_2568" data-name="Group 2568" transform="translate(272.777 -136.407)">
                <g id="news-admin" transform="translate(35.583 302.407)">
                    <path id="Path_69934" data-name="Path 69934"
                          d="M18.716,20.916H14.423V17.565A.565.565,0,0,0,13.858,17H.565A.565.565,0,0,0,0,17.565V32.176A2.827,2.827,0,0,0,2.824,35H16.456a2.827,2.827,0,0,0,2.824-2.824V21.481A.565.565,0,0,0,18.716,20.916ZM2.824,33.87A1.7,1.7,0,0,1,1.13,32.176V18.13H13.293c0,14.93-.007,14.1.013,14.313a2.815,2.815,0,0,0,.553,1.428Zm15.326-1.695a1.7,1.7,0,0,1-1.695,1.695h-.339a1.7,1.7,0,0,1-1.695-1.695V22.046h3.728Z"
                          transform="translate(0 -17)" fill="#799cfb"/>
                    <path id="Path_69935" data-name="Path 69935"
                          d="M74,89H65.565a.565.565,0,1,0,0,1.13H74A.565.565,0,1,0,74,89Z"
                          transform="translate(-62.552 -86.289)" fill="#799cfb"/>
                    <path id="Path_69936" data-name="Path 69936"
                          d="M74,153H65.565a.565.565,0,1,0,0,1.13H74A.565.565,0,0,0,74,153Z"
                          transform="translate(-62.552 -147.879)" fill="#799cfb"/>
                    <path id="Path_69937" data-name="Path 69937"
                          d="M74,393H65.565a.565.565,0,0,0,0,1.13H74A.565.565,0,0,0,74,393Z"
                          transform="translate(-62.552 -378.841)" fill="#799cfb"/>
                    <path id="Path_69938" data-name="Path 69938"
                          d="M181.782,217h-4.218a.565.565,0,0,0-.565.565v4.218a.565.565,0,0,0,.565.565h4.218a.565.565,0,0,0,.565-.565v-4.218A.565.565,0,0,0,181.782,217Zm-.565,4.218H178.13V218.13h3.088Z"
                          transform="translate(-170.335 -209.469)" fill="#799cfb"/>
                    <path id="Path_69939" data-name="Path 69939"
                          d="M65.565,242.13h1.808a.565.565,0,1,0,0-1.13H65.565a.565.565,0,1,0,0,1.13Z"
                          transform="translate(-62.552 -232.565)" fill="#799cfb"/>
                    <path id="Path_69940" data-name="Path 69940"
                          d="M65.565,306.13h1.808a.565.565,0,1,0,0-1.13H65.565a.565.565,0,1,0,0,1.13Z"
                          transform="translate(-62.552 -294.155)" fill="#799cfb"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IReport",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
